import { Navigate, useParams } from "react-router-dom";

/**
 * Legacy route kept for backward compatibility (old emails, bookmarks).
 * Findings now live inline on the cat page; we redirect with a hash anchor
 * so the findings section scrolls into view.
 */
export function CatMessagesPage() {
  const { id } = useParams<{ id: string }>();
  return <Navigate to={`/app/pets/${id}#findings`} replace />;
}
